// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1tR3s","info":"styles_info__10nM7","label":"styles_label__2aNkl","line":"styles_line__34MZi","resetPasswordLink":"styles_resetPasswordLink__3V8_O"};